import { useState } from 'react'
import SVG from 'react-inlinesvg'
import { IconEditModal } from '../../../Commons/Servicos/components/IconEditModal'
import { PUT } from '../../../../services/api'
import Swal from 'sweetalert2'

export const ListIcons = (props: {icons: any; category: any; onIconUpdated?: () => void}) => {
  const {icons, category, onIconUpdated} = props
  const [editingIcon, setEditingIcon] = useState<any>(null)
  const [showEditModal, setShowEditModal] = useState(false)
  
  const arr = icons.filter((row: any) => row.category === category)
  
  const handleEditClick = (icon: any) => {
    setEditingIcon({
      id: icon.id,
      name: icon.description,
      description: icon.description,
      svg: icon.svg,
      svg_content: icon.svg,
      category: icon.category
    })
    setShowEditModal(true)
  }

  const handleIconUpdated = async (updatedIcon: any) => {
    try {
      await PUT(`/svgwebapp/${updatedIcon.id}`, {
        description: updatedIcon.name,
        svg: updatedIcon.svg_content,
        category: editingIcon.category
      });

      if (onIconUpdated) {
        onIconUpdated()
      }

      Swal.fire({
        title: 'Sucesso!',
        text: 'Ícone atualizado com sucesso.',
        icon: 'success',
      })
      
    } catch (error) {
      console.error('Erro ao atualizar ícone:', error)
      Swal.fire({
        title: 'Erro!',
        text: 'Não foi possível atualizar o ícone.',
        icon: 'error',
      })
    }
  }

  return (
    <>
      {arr.map((icon: any) => (
        <div
          key={icon.id}
          className="position-relative"
          style={{
            border: '1px solid #c9c9c9',
            margin: '2px',
            padding: '2px',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          <SVG
            src={icon.svg}
            width={50}
            height={50}
            uniquifyIDs={true}
            description={icon.description}
            title={icon.description}
          />
          
          {/* Botão de edição */}
          <button
            className="btn btn-sm btn-primary position-absolute"
            style={{
              top: '-5px',
              right: '-5px',
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              padding: '0',
              fontSize: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => handleEditClick(icon)}
            title="Editar ícone"
          >
            ✏️
          </button>
        </div>
      ))}

      {/* Modal de Edição de Ícone */}
      <IconEditModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        icon={editingIcon}
        onSave={handleIconUpdated}
      />
    </>
  )
}
